// extracted by mini-css-extract-plugin
module.exports = {"table":"projects-table-module--table--22YX0","tableRow":"projects-table-module--table-row--3KG_V","tableColumn":"projects-table-module--table-column--14Muo"};